import EditorJS from '@editorjs/editorjs'
import Header from '@editorjs/header'
import ImageTool from '@editorjs/image'
import List from '@editorjs/list'
// import Link from '@editorjs/link'
import { useEffect, useRef } from 'react'
import { DirectUpload } from '@rails/activestorage'

interface Props {
  content: string
  onChange: (content: string) => void
}

const uploadByFile = (file: File) => {
  const url = import.meta.env.VITE_RIPPLE_DIRECT_UPLOAD_ENDPOINT
  const upload = new DirectUpload(file, url)

  return new Promise(function (resolve, reject) {
    upload.create((error, blob) => {
      if (error) {
        reject(error)
      } else if (blob === undefined) {
        reject('Blob is unexpectedly undefined')
      } else {
        fetch(`${import.meta.env.VITE_RIPPLE_BLOCKS_ENDPOINT}/image_url/${blob.signed_id}`)
          .then(response => response.json())
          .then(imageUrlResp => {
            console.log(imageUrlResp)
            resolve({
              success: 1,
              file: {
                url: imageUrlResp.url,
                attachable_sgid: blob.signed_id,
              },
            })
          })
      }
    })
  })
}

const placeholder = {
  blocks: [
    {
      type: 'header',
      data: {
        text: 'All the world\'s a stage',
        level: 1
      }
    },
    {
      type: 'paragraph',
      data: {
        text: 'So let\'s make something awesome'
      }
    }
  ]
}

const tools = {
  header: Header,
  list: List,
  // link: {
  //   class: Link,
  //   config: {
  //     endpoint: `${import.meta.env.VITE_RIPPLE_BLOCKS_ENDPOINT}/link_details`
  //   }
  // },
  image: {
    class: ImageTool,
    config: {
      uploader: { uploadByFile }
    }
  }
}

export const Editor = ({ content, onChange }: Props) => {
  const isReady = useRef(false)

  const initEditor = () => {
    if (isReady.current) return
    isReady.current = true

    const editor = new EditorJS({
      holder: 'editorjs',
      tools,
      // onReady: () => {
      //   isReady.current = true
      // },
      data: content ? JSON.parse(content) : placeholder,
      onChange: async () => {
        await editor.saver.save().then(content => onChange(JSON.stringify(content)))
      },
      autofocus: true
    })
  }

  useEffect(() => {
    initEditor()
  }, [])

  return (
    <div className="bg-zinc-100 text-zinc-950">
      <div className="w-full">
        <div id="editorjs" />
      </div>
    </div>
  )
}
